import { render, staticRenderFns } from "./modal-loyalty-link.vue?vue&type=template&id=2b28a41a&"
import script from "./modal-loyalty-link.vue?vue&type=script&lang=js&"
export * from "./modal-loyalty-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports